import Login from "./login";

import { Box } from "@mui/material";

export default class signupInvite extends Login {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state
        };
    }
    renderForm() {

        return (
            <Box className="flex column gap24">
                <Box className="flex gap24 colOnSmall">
                    {this.insertPassword("password", "", "password")}
                    {this.insertPassword("passwordConfirm", "", "confirm")}
                </Box>
                {/*{this.insertSelect(timezone, timezones, this.changeInputValue.bind(this, "timezone"))}*/}
                {/*{this.insertButton("signup")}*/}
            </Box>
        );
    }
}